/* eslint-disable new-cap */

export function fromStrategyEmbedCode(dyVariables) {
    import('./recommendations.js').then(({ default: render }) => render({
        strategyId: dyVariables[0],
        element: dyVariables[1],
        type: dyVariables[2],
        containerId: dyVariables[3],
        heading: dyVariables[4],
        headingTag: dyVariables[5],
        subHeading: dyVariables[6],
        subHeadingLink: dyVariables[7],
        imageWidth: dyVariables[8],
        numberToDisplay: +dyVariables[9],
        headingClassName: dyVariables[10],
    }));
}

export function audienceEvent(customer, forceEventFire) {
    if (!customer) {
        return;
    }

    var STORAGE_KEY = 'audienceEventFired',
        keys = ['ExistingCustomer', 'HasActiveSubscription', 'PrimaryDiscipline', 'ATSSmartPaks'];

    if (sessionStorage.getItem(STORAGE_KEY) !== 'true' || forceEventFire) {
        event(
            'Audience',
            keys.reduce(function (audience, key) {
                audience[key] = customer[key];

                return audience;
            }, {})
        );

        sessionStorage.setItem(STORAGE_KEY, 'true');
    }
}

export function indentity(email) {
    if (email && window.DY && window.DY.API && window.DYO) {
        window.DY.API('identify', {
            uid: window.DYO.dyhash.sha256(email),
            type: 'he'
        });
    }
}

export function searchEvent(searchText) {
    event('Keyword Search', {
        dyType: 'keyword-search-v1',
        keywords: searchText
    });
}

export function event(eventName, eventObject) {
    if (window.DY && window.DY.API) {
        var eventProperties = {};

        Object.keys(eventObject).forEach(function (key) {
            if (typeof eventObject[key] === 'function') {
                return;
            }
            if (typeof eventObject[key] === 'undefined' || typeof eventObject[key] === 'number') {
                eventProperties[key] = eventObject[key];
            } else {
                eventProperties[key] = eventObject[key].toString();
            }
        });

         
        window.DY.API('event', {
            name: eventName,
            properties: eventProperties
        });
    }
}

export function signUpEvent(email) {
    const hashedEmail = getHashedEmail(email);
    window.DY.API('event', {
        name: 'Signup',
        properties: {
            dyType: 'signup-v1',
            hashedEmail: hashedEmail
        }
    });
}

export function newsLetterSubscriptionEvent(email) {
    var hashedEmail = getHashedEmail(email);
    window.DY.API('event', {
        name: 'Newsletter Subscription',
        properties: {
            dyType: 'newsletter-subscription-v1',
            hashedEmail: hashedEmail
        }
    });
}

export function loginEvent(email) {
    if (!window.DY || !window.DYO) {
        return;
    }

    window.DY.API('event', {
        name: 'Login',
        properties: {
            dyType: 'login-v1',
            hashedEmail: getHashedEmail(email)
        }
    });
}

export function getHashedEmail(emailAddress) {
    return window.DYO.dyhash.sha256(emailAddress.toLowerCase());
}

export function fireUTMCampaignEvents() {
    const params = new URLSearchParams(location.search),
        param = 'utm_campaign',
        prefix = 'dy_utm_camp_';

    if (params.has(param)) {
        const d = new Date(),
            name = params.get(param);

        d.setTime(d.getTime() + 31 * 24 * 60 * 60 * 1e3);

        document.cookie = prefix + name + '=1;path=/; expires=' + d.toGMTString() + ';';
    }

    if (!document.cookie.includes(prefix)) {
        return;
    }

    document.cookie.split(';')
        .filter(cookie => cookie.includes(prefix))
        .forEach(cookie => {
            event('UTM_Campaign_ready', {
                name: cookie.trim().split('=')[0].replace(prefix, '')
            });
        });
}

export function getUserLocation() {
    return utils.ready(() => window?.DY?.geoFields);
}

function ready(evaluator) {
    const allowedAttempts = 150;
    const timeout = 200;
    let attempt = 1;

    return new Promise(res => {
        function checkForInstance() {
            const instance = evaluator();

            if (instance) {
                res(instance);
                return;
            }

            if (attempt <= allowedAttempts) {
                attempt++;
                setTimeout(checkForInstance, timeout);
            }
        }

        checkForInstance();
    });
}

export const utils = {
    ready
};